
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AggregationResource,
  FreelancerProjectsManagementSearchResultResource,
  ValidationError,
} from '../models';
import {
    AggregationResourceFromJSON,
    AggregationResourceToJSON,
    FreelancerProjectsManagementSearchResultResourceFromJSON,
    FreelancerProjectsManagementSearchResultResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface FilterAggregateRequest {
    aggregateName: string;
    aggregateFilter?: string;
    query?: string;
    identityId?: string;
    owners?: Array<string>;
    companies?: Array<string>;
    organizations?: Array<string>;
    actions?: Array<FilterAggregateActionsEnum>;
    status?: Array<FilterAggregateStatusEnum>;
    freelancers?: Array<string>;
    startDateFrom?: Date;
    startDateTo?: Date;
    endDateFrom?: Date;
    endDateTo?: Date;
}

export interface SearchRequest {
    query?: string;
    identityId?: string;
    owners?: Array<string>;
    companies?: Array<string>;
    organizations?: Array<string>;
    actions?: Array<SearchActionsEnum>;
    status?: Array<SearchStatusEnum>;
    freelancers?: Array<string>;
    startDateFrom?: Date;
    startDateTo?: Date;
    endDateFrom?: Date;
    endDateTo?: Date;
    sortBy?: SearchSortByEnum;
    sortOrder?: SearchSortOrderEnum;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class ProjectFreelancerListApi extends runtime.BaseAPI {

    /**
          */
    async filterAggregateRaw(requestParameters: FilterAggregateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<{ [key: string]: Array<AggregationResource>; }>> {
        if (requestParameters['aggregateName'] == null) {
            throw new runtime.RequiredError(
                'aggregateName',
                'Required parameter "aggregateName" was null or undefined when calling filterAggregate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aggregateFilter'] != null) {
            queryParameters['aggregateFilter'] = requestParameters['aggregateFilter'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['identityId'] != null) {
            queryParameters['identityId'] = requestParameters['identityId'];
        }

        if (requestParameters['owners'] != null) {
            queryParameters['owners'] = requestParameters['owners']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companies'] != null) {
            queryParameters['companies'] = requestParameters['companies']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['organizations'] != null) {
            queryParameters['organizations'] = requestParameters['organizations']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['actions'] != null) {
            queryParameters['actions'] = requestParameters['actions']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['freelancers'] != null) {
            queryParameters['freelancers'] = requestParameters['freelancers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = (requestParameters['startDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = (requestParameters['startDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = (requestParameters['endDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = (requestParameters['endDateTo'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<{ [key: string]: Array<AggregationResource>; }>({
            path: `/project-freelancer/api/aggregate/{aggregateName}`.replace(`{${"aggregateName"}}`, encodeURIComponent(String(requestParameters['aggregateName']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async filterAggregate(requestParameters: FilterAggregateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<AggregationResource>; }> {
        const response = await this.filterAggregateRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerProjectsManagementSearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['identityId'] != null) {
            queryParameters['identityId'] = requestParameters['identityId'];
        }

        if (requestParameters['owners'] != null) {
            queryParameters['owners'] = requestParameters['owners']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['companies'] != null) {
            queryParameters['companies'] = requestParameters['companies']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['organizations'] != null) {
            queryParameters['organizations'] = requestParameters['organizations']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['actions'] != null) {
            queryParameters['actions'] = requestParameters['actions']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['freelancers'] != null) {
            queryParameters['freelancers'] = requestParameters['freelancers']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['startDateFrom'] != null) {
            queryParameters['startDateFrom'] = (requestParameters['startDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['startDateTo'] != null) {
            queryParameters['startDateTo'] = (requestParameters['startDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateFrom'] != null) {
            queryParameters['endDateFrom'] = (requestParameters['endDateFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateTo'] != null) {
            queryParameters['endDateTo'] = (requestParameters['endDateTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerProjectsManagementSearchResultResource>({
            path: `/project-freelancer/api/project/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerProjectsManagementSearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async search(requestParameters: SearchRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerProjectsManagementSearchResultResource> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return response._data;
    }

}

/**
 * @export
 */
export const FilterAggregateActionsEnum = {
    ModifyQuote: 'MODIFY_QUOTE',
    CompleteActivityTracker: 'COMPLETE_ACTIVITY_TRACKER',
    CompleteMission: 'COMPLETE_MISSION',
    LetProjectAppraisal: 'LET_PROJECT_APPRAISAL',
    GotoBusinessSettings: 'GOTO_BUSINESS_SETTINGS'
} as const;
export type FilterAggregateActionsEnum = typeof FilterAggregateActionsEnum[keyof typeof FilterAggregateActionsEnum];
/**
 * @export
 */
export const FilterAggregateStatusEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AcceptanceBlocked: 'ACCEPTANCE_BLOCKED',
    Upcoming: 'UPCOMING',
    InProgress: 'IN_PROGRESS',
    PaymentOnHold: 'PAYMENT_ON_HOLD',
    Ended: 'ENDED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    QuoteExpired: 'QUOTE_EXPIRED',
    PendingCompliance: 'PENDING_COMPLIANCE'
} as const;
export type FilterAggregateStatusEnum = typeof FilterAggregateStatusEnum[keyof typeof FilterAggregateStatusEnum];
/**
 * @export
 */
export const SearchActionsEnum = {
    ModifyQuote: 'MODIFY_QUOTE',
    CompleteActivityTracker: 'COMPLETE_ACTIVITY_TRACKER',
    CompleteMission: 'COMPLETE_MISSION',
    LetProjectAppraisal: 'LET_PROJECT_APPRAISAL',
    GotoBusinessSettings: 'GOTO_BUSINESS_SETTINGS'
} as const;
export type SearchActionsEnum = typeof SearchActionsEnum[keyof typeof SearchActionsEnum];
/**
 * @export
 */
export const SearchStatusEnum = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    AcceptanceBlocked: 'ACCEPTANCE_BLOCKED',
    Upcoming: 'UPCOMING',
    InProgress: 'IN_PROGRESS',
    PaymentOnHold: 'PAYMENT_ON_HOLD',
    Ended: 'ENDED',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    QuoteExpired: 'QUOTE_EXPIRED',
    PendingCompliance: 'PENDING_COMPLIANCE'
} as const;
export type SearchStatusEnum = typeof SearchStatusEnum[keyof typeof SearchStatusEnum];
/**
 * @export
 */
export const SearchSortByEnum = {
    ProjectTitle: 'PROJECT_TITLE',
    Status: 'STATUS',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
    SortDateForFreelancer: 'SORT_DATE_FOR_FREELANCER',
    ProjectOwner: 'PROJECT_OWNER',
    Company: 'COMPANY',
    Organization: 'ORGANIZATION',
    Freelancer: 'FREELANCER',
    Total: 'TOTAL',
    Action: 'ACTION'
} as const;
export type SearchSortByEnum = typeof SearchSortByEnum[keyof typeof SearchSortByEnum];
/**
 * @export
 */
export const SearchSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SearchSortOrderEnum = typeof SearchSortOrderEnum[keyof typeof SearchSortOrderEnum];
